'use client';

import { useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';
import cx from 'classnames';

interface SectionProps {
    id?: string;
    className?: string;
    onInViewport?: (inViewport: boolean) => void;
    inViewOptions?: {
        root?: React.RefObject<Element>;
        margin?: string;
        once?: boolean;
        amount?: 'some' | 'all' | number;
    };
    children?: React.ReactNode;
}

const Section = ({ id, className = '', onInViewport, inViewOptions = {}, children }: SectionProps) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { margin: '0px 0px -25% 0px', ...inViewOptions });

    useEffect(
        () => {
            if (typeof onInViewport === 'function') {
                onInViewport(isInView);
            }
        },
        [isInView, onInViewport]
    );

    return (
        <section id={id} ref={ref} className={cx('relative', {
            'py-12 sm:py-16': ! ['p-', 'pt-', 'pb-', 'py-'].some(c => className.split(' ').some(n => n.startsWith(c))),
            'my-10 sm:my-20': ! ['m-', 'mt-', 'mb-', 'my-'].some(c => className.split(' ').some(n => n.startsWith(c))),
            [className || '']: Boolean(className)
        })}>
            {children}
        </section>
    );
};

export { Section };